module.exports = __webpack_public_path__ + "static/PatrickHand-Regular-b8a9e4f7abe18ad6fe7a3e0bad7067af.woff2";